module.exports = __webpack_public_path__ + "img/a110c84.jpg";